import { createRoot } from 'react-dom/client'
import { App } from './App'

document.addEventListener('DOMContentLoaded', function () {
	const container = document.getElementById('app-calculadora-sou')
	const lang = container.dataset.lang || 'ca'
	const preview = new URLSearchParams(window.location.search).get('preview') === '1'
	const root = createRoot(container)
	root.render(<App lang={lang} preview={preview} />)
})
